import React, {Component} from 'react';
import Select from 'react-select';

import 'react-big-calendar/lib/sass/styles.scss';
import styles from './styles.module.scss';

import Calendar from './timezone_calendar';
import SchedulerPopup from './popup';

export default class View extends Component {
    calendarRef = React.createRef();

    componentDidMount() {
        this.props.fetchProgramSchedules();
        this.props.fetchCategories();
        this.setupClickHandler();
    }

    componentDidUpdate() {
        this.setupClickHandler();
    }

    componentWillUnmount() {
        if (this.calendarRef.current) {
            const monthView = this.calendarRef.current.querySelector('.rbc-month-view');
            if (monthView) {
                monthView.removeEventListener('click', this.handleCalendarClick);
                delete monthView.dataset.clickBound;
            }
        }
    }

    setupClickHandler = () => {
        if (!this.calendarRef.current) return;

        const monthView = this.calendarRef.current.querySelector('.rbc-month-view');
        if (monthView && !monthView.dataset.clickBound) {
            monthView.dataset.clickBound = 'true';
            monthView.addEventListener('click', this.handleCalendarClick);
        }
    }

    handleCalendarClick = (e) => {
        // Ignore clicks on events - they're handled by onSelectEvent
        if (e.target.closest('.rbc-event')) {
            return;
        }

        // Find if we clicked on a date cell or its children
        const dateCell = e.target.closest('.rbc-date-cell');
        const dayBg = e.target.closest('.rbc-day-bg');

        if (dateCell || dayBg) {
            // Get the row to find which week we're in
            const row = (dateCell || dayBg).closest('.rbc-month-row');
            if (!row) return;

            // Get all rows and cells to determine the date
            const rows = Array.from(this.calendarRef.current.querySelectorAll('.rbc-month-row'));
            const rowIndex = rows.indexOf(row);

            let cellIndex;
            if (dateCell) {
                const cells = Array.from(row.querySelectorAll('.rbc-date-cell'));
                cellIndex = cells.indexOf(dateCell);
            } else {
                const cells = Array.from(row.querySelectorAll('.rbc-day-bg'));
                cellIndex = cells.indexOf(dayBg);
            }

            // Get the date from the button text
            const button = dateCell ? dateCell.querySelector('.rbc-button-link') :
                           row.querySelectorAll('.rbc-date-cell')[cellIndex]?.querySelector('.rbc-button-link');

            if (button) {
                const dayNum = parseInt(button.textContent, 10);
                const header = this.calendarRef.current.querySelector('.rbc-toolbar-label');
                if (header) {
                    const [month, year] = header.textContent.split(' ');
                    const monthIndex = new Date(Date.parse(month + " 1, 2000")).getMonth();
                    const date = new Date(parseInt(year), monthIndex, dayNum);

                    this.props.createSchedule(
                        this.props.match.params.programid,
                        date,
                        this.props.programLengthInDays
                    );
                }
            }
        }
    }

    _renderFilter() {
        if (!this.props.groups) {
            return null;
        }

        var groups = this.props.groups.map(model => ({
            type: model.type,
            value: model.id,
            label: model.description,
        }));
        groups.unshift({
            type: 'all',
            value: 'all',
            label: 'Everyone',
        })

        if (this.props.selectedGroup) {
            var value = groups.find(g => g.type === 'group' && g.value === this.props.selectedGroup);
        } else if (this.props.selectedTeam) {
            var value = groups.find(g => g.type === 'team' && g.value === this.props.selectedTeam);
        } else {
            var value = groups[0];
        }

        return (<div className={styles.selectContainer}>
            <Select
                name="category"
                className={styles.select}
                clearable={false}
                deleteRemoves={false}
                value={value}
                onChange={(selectedOption)=> {
                    if (selectedOption) {
                        switch (selectedOption.type) {
                        case 'group':
                            this.props.updateGroupFilter(null, selectedOption.value);
                            break;
                        case 'team':
                            this.props.updateGroupFilter(selectedOption.value, null);
                            break;
                        default:
                            this.props.updateGroupFilter(null, null);
                            break;
                        }
                    }
                }}
                options={groups}
                components={{
                    IndicatorSeparator: () => null
                }}
            />
        </div>);
    }

    render() {
        const popup = this.props.modalVisible ? <SchedulerPopup /> : null;
        return (
            <div>
                <div className={styles.calendarControls}>
                {this._renderFilter()}
                <h1 className={styles.description}>Choose start date</h1>
                </div>
                <div ref={this.calendarRef}>
                    <Calendar
                        className={styles.cal}
                        events={this.props.calendarEvents}
                        views={['month']}
                        selectable={false}
                        startAccessor="start"
                        endAccessor="end"
                        popup={true}
                        onSelectEvent={(slotInfo)=>this.props.editSchedule(slotInfo.id, slotInfo.start, slotInfo.end)}
                        />
                </div>
                {popup}
            </div>
        );
    };

};
